<template>
    <v-tab-item :value="KATA.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <v-divider class="primary"></v-divider>
                <v-row no-gutters>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">빠른 소싱(Sourcing)</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>고객님이 원하시는 작품을 빠르게 찾아 드리기 위해 항상 최선을 다합니다.</li>
                                                <li>캐터옥션은 해외 미술품 수입에 대한 최고의 노하우를 보유하고 있습니다.</li>
                                                <li>해외 블루 칩 작가 및 Hot Emerging Artist 작품을 신속 정확하게 직구 합니다.</li>
                                            </ul>
                                        </div>
                                        <div class="mt-14 mt-md-20">
                                            <p class="page-text">※ 작품의 독특함과 희소성, 가격변동에 따라 직구 및 거래 시점이 변동될 수 있습니다.</p>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon2.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">높은 보안성, 기밀성</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>우리는 최고의 기밀을 유지하면서, 고객에게 가장 유익한 결과가 달성될 수 있도록 노력합니다.</li>
                                                <li>고객의 신원 및 개인판매 문의는 엄격하게 기밀로 유지됩니다.</li>
                                                <li>고객이 명시적인 공개를 원하는 경우가 아니면 고객의 신원을 절대 공개하지 않습니다.</li>
                                            </ul>
                                        </div>
                                        <div class="mt-14 mt-md-20">
                                            <p class="page-text">※ 캐터옥션 홈페이지에 작품을 업로드 하는 것이 부담스러울 경우, 내리고 진행할 수도 있습니다.</p>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon3.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">광범위한 네트워크 및 마케팅 전개</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>프라이빗 세일에 적합한 구매자와 판매자를 상호 매칭하기 위하여, 캐터옥션에서는 광범위한 국내 및 국제 네트워크를 최대한 활용합니다.</li>
                                                <li>신중하며 고도로 맞춤화된 네트워크는 고객께서 필요로 하시는 최고의 작품을 판매 또는 구입하는데 도움을 드립니다.</li>
                                                <li>캐터옥션은 SNS, 온라인 광고, 유튜브 방송 등을 다양한 마케팅을 전개합니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon4.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">1:1 맞춤 서비스</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>다년간의 아트 비즈니스 경험을 바탕으로, 위탁자 및 구매자에게 1:1 맞춤 서비스를 제공합니다.</li>
                                                <li>당사는 고객의 특정 요구 사항에 가장 유익한 맞춤형 구매/판매 전략을 활용합니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon5.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">최저가 수수료 : 5%</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>프라이빗 세일에서 판매된 작품의 수수료는, 일반경매작품과 동일하게 적용합니다.</li>
                                                <li>다만, 해외에서 구입하는 작품의 수수료는 8% (실비 제외)를 적용합니다.</li>
                                            </ul>
                                        </div>
                                        <div class="mt-14 mt-md-20">
                                            <p class="page-text">※ 판매수수료에 대한 자세한 내용은 다음을 참조하시기 바랍니다.</p>
                                        </div>
                                        <div class="mt-4">
                                            <v-btn small text height="auto" color="grey-68" to="/" class="pa-0 v-btn--none-active-bg"><strong>자세히보기</strong><v-icon>mdi-menu-right</v-icon></v-btn>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon6.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">기관 소장품의 <br class="d-none d-md-block" />빠른 판매</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>기업, 은행, 협단체, 미술관, 박물관 등 기관/단체 소장품에 대하여 신속한 판매전략을 활용합니다.</li>
                                                <li>기관 소장품은 실사 → 상태검사 → 가격산정 → 활용/판매 방안을 포함한 별도의 &lt;작품매각 프로그램&gt;하에 판매를 진행합니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <div class="h-100 px-10 py-20 py-md-30">
                            <v-row no-gutters>
                                <v-col cols="12" md="2">
                                    <div class="w-140px w-md-100 ma-auto">
                                        <v-img contain width="180" max-height="180" src="/images/sub/private/private-strength-icon7.png"></v-img>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <div class="pt-16 pl-md-20">
                                        <h5 class="tit tit--xs line-height-14">작품의 잠재가치 발굴 및 부가가치 제고</h5>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div class="pt-16 pl-md-60">
                                        <div>
                                            <ul class="dot-list dot-list--large">
                                                <li>의뢰받은 작품에 대한 미술사적 분석을 실시한 후에 &lt;작품설명서&gt;를 발행합니다.</li>
                                                <li>정밀한 상태검사 및 이력 조사를 실시한 후에 &lt;상태검사서&gt; 및 &lt;작품이력서&gt;를 발행합니다.</li>
                                                <li>캐터옥션의 프라이빗 세일에 출품되었음을 확인하는 &lt;출품확인서&gt;를 발행합니다.</li>
                                                <li>의뢰인에게 받은 &lt;진품보증서&gt;를 구매인에게 전달하여, 작품의 진품성을 확보합니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                    </v-col>
                </v-row>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_TABS } from "@/assets/variables";
const { KATA } = PRIVATE_SALES_TABS;
export default {
    data() {
        return {
            KATA,
        };
    },
};
</script>

<style></style>
